import { Badge, Menu } from "antd";
import {
  defaultMenu,
  menuItemsTransformer,
} from "layouts/services/data.transformers";
import Loading from "./menuLoading";

const MenuWrapper = ({
  activeMenu,
  handleClickMenu,
  mode,
  className,
  menuItems,
  windowWidth,
  loading,
}) => {
  const menu = menuItems || defaultMenu();
  const handleBadgeStyle = () => {
    return windowWidth > 768 ? [2, 2] : [-5, 4];
  };

  const renderedItems = menuItemsTransformer(menu)?.map(
    ({ label, key, icon, activeIcon, newFeature }) => {
      const menuIcon = (
        <img
          className="h-6 w-6"
          src={activeMenu === key ? activeIcon : icon}
          width="24"
          height="24"
          alt="menu icon"
        />
      );

      return {
        key,
        icon:
          newFeature && activeMenu !== key ? (
            <Badge
              count={"جدید"}
              color="#E51B49"
              offset={handleBadgeStyle()}
              className="new-badge"
            >
              {menuIcon}
            </Badge>
          ) : (
            menuIcon
          ),
        label,
      };
    }
  );

  return loading ? (
    <Loading mode={mode} />
  ) : (
    <Menu
      className={className}
      onClick={handleClickMenu}
      selectedKeys={[activeMenu]}
      mode={mode}
      items={renderedItems}
    />
  );
};

export default MenuWrapper;
